export enum UserRole {
    ADMIN = 'ROLE_ADMIN',
    HEAD_OF_HR = 'ROLE_HEAD_OF_HR',
    PERSONAL = 'ROLE_PERSONAL',
    COACH = 'ROLE_COACH',
    THERAPIST = 'ROLE_THERAPIST',
    ACCOUNTANT = 'ROLE_ACCOUNTANT',
    SITE_MANAGER = 'ROLE_SITE_MANAGER',
    SITE_SUPPORT = 'ROLE_SITE_SUPPORT',
    HEAD_OF_AMDL = 'ROLE_HEAD_OF_AMDL',
    HEAD_OF_MARKETING = 'ROLE_HEAD_OF_MARKETING',
    HEAD_OF_PSYCHOSOCIAL_SERVICES = 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES',
    PRACTICE_MANAGER = 'ROLE_PRACTICE_MANAGER',
    HEAD_OF_OCCUPATIONAL_THERAPY = 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY',
    ASSISTANT_VQ = 'ROLE_ASSISTANT_VQ',
    USER = 'ROLE_USER',
}